import React, { useState, useHook, useEffect, useRef } from 'react';
import Header from '../Header';
import SideBar from '../SideBar';
import Footer from '../Footer';
import Loader from '../Loader';
import { get, post, put, deleteM } from "../../utility/Adapter";
import { withParams } from "../HOC";
import axios from 'axios';
import Parser from 'html-react-parser';

const CandidateProfile = (props) => {
    const [loading, setLoading] = useState(false);
    const [percentage, setPercentage] = useState('0%');
    const [saveBtn, setSaveBtn] = useState(false);
    const [departments, setDepartments] = useState([]);
    const [myProfile, setMyProfile] = useState({
        candidate_education_details: {
            course_start_f: null,
            course_end_f: null,
            school_name: null,
            board_name: null,
            state: null
        },
        candidate_nurse_course: {

        },
        candidate_language_course: {

        }
    });
    const [countries, setCountries] = useState([]);
    const [nationality, setNationality] = useState([]);
    const [speaking, setSpeaking] = useState([]);
    const [hobbies, setHobbies] = useState([]);
    const [designations, setDesignations] = useState([]);
    const [languageSkills, setLanguageSkills] = useState([]);
    const [candidateStatus, setCandidateStatus] = useState(0);
    const [step, setStep] = useState("0");
    const [candidateId, setCandidateId] = useState(null);
    const [image, setImage] = useState(null);
    const [candidateResume, setCandidateResume] = useState(null);
    const [schoolsDiv, setSchoolsDiv] = useState(null);
    const [schoolsArr, setSchoolsArr] = useState([]);
    const [candidateSchools, setCandidateSchools] = useState([]);
    const [candidateCollege, setCandidateCollege] = useState([]);

    const [courseDiv, setCourseDiv] = useState(null);
    const [courseArr, setCourseArr] = useState([]);
    const [affliators, setAffliators] = useState([]);



    useEffect(() => {
        _loadDepartments();
    }, []);

    useEffect(() => {
        _loadProfile();
        //_loadCountry();
        //_loadNationality();
        //_loadSpeaking();
       // _loadHobbies();
        //_loadDesignations();
        _loadAffliates();


        /*setTimeout(function () {
            window.$(function () {
                
                window.$(".date-picker").datepicker({
                    dateFormat: 'MM yy',
                    changeMonth: true,
                    changeYear: true,
                    showButtonPanel: true,
                    maxDate: '+28D',
                    yearRange: '1970:2023',

                    onClose: function (dateText, inst) {
                        function isDonePressed() {
                            return (window.$('#ui-datepicker-div').html().indexOf('ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all ui-state-hover') > -1);
                        }
                        if (isDonePressed()){
                            var month = window.$("#ui-datepicker-div .ui-datepicker-month :selected").val();
                            var year = window.$("#ui-datepicker-div .ui-datepicker-year :selected").val();
                            window.$(this).val(window.$.datepicker.formatDate('MM yy', new Date(year, month, 1)));
                        }
                    }
                });

                window.$(".date-picker").focus(function () {
                    window.$(".ui-datepicker-calendar").hide();
                    window.$("#ui-datepicker-div").position({
                        my: "center top",
                        at: "center bottom",
                        of: window.$(this)
                    });
                });
            });
            
        }, 10000);*/
      }, [departments]);

    const _loadAffliates = () => {
        setLoading(true);

        get('affiliators').then(async function (response) {
            setAffliators(response.data.data);
        });

    }

    const _loadDepartments = () => {
        get('departments/en').then(async function (response) {
            setDepartments(response.data.data);
        }).catch(function (error) {
            console.log(error);
            setDepartments([])
        });
    }

    const _loadProfile = () => {
        setLoading(true);
        get('admin/candidate/profile/' + props.params.id).then(async function (response) {
            setLoading(false);
            setMyProfile(response.data.data);
            setCandidateStatus(response.data.data.candidate_status);
            setStep(response.data.data.candidate_step);
            setCandidateId(response.data.data.candidate_id);
            setCandidateResume(response.data.data.candidate_resume);
            setCandidateSchools(response.data.data.candidate_schools);

            if (response.data.data.candidate_status == 1) {
                document.getElementById("not_started").checked = true;
            }

            if (response.data.data.candidate_status == 2) {
                document.getElementById("in_progress").checked = true;
            }

            if (response.data.data.candidate_status == 3) {
                document.getElementById("completed").checked = true;
            }

            if (response.data.data.candidate_colleges != undefined)
                setCandidateCollege(response.data.data.candidate_colleges);

            

            if (response.data.data.candidate_image != null) {
                let candidateImage = response.data.data.candidate_image;
                const isAbsoluteUrl = candidateImage.startsWith('http') || candidateImage.startsWith('https');
                if (!isAbsoluteUrl && !candidateImage.includes('.')) {
                    candidateImage += '.png';
                }
                setImage(isAbsoluteUrl ? candidateImage : process.env.REACT_APP_BASE_URL + "candidates/images/" + candidateImage);
            }

            

            setTimeout(function () {

                if (response.data.data.candidate_note != undefined) {
                    document.getElementById("note").value = response.data.data.candidate_note;
                } else if (response.data.data.candidate_notes != undefined) {
                    document.getElementById("note").value = response.data.data.candidate_notes;
                } else if (response.data.data.candidate_additional_note != undefined) {
                    document.getElementById("note").value = response.data.data.candidate_additional_note;
                }

                if (response.data.data.affiliator_id != undefined && response.data.data.affiliator_id != null && response.data.data.affiliator_id != "") {
                    document.getElementById("affiliator").value = response.data.data.affiliator_id;
                }

                if (response.data.data.candidate_affiliator_status != undefined) {
                    document.getElementById("affiliate_status").value = response.data.data.candidate_affiliator_status;
                }

                if (response.data.data.candidate_affiliator_note != undefined) {
                    document.getElementById("affiliator_note").value = response.data.data.candidate_affiliator_note;
                }
            }, 1000);

        }).catch(function (error) {
            setLoading(false);
            console.log(error);
        });
    }

    const _loadCountry = () => {
        get('countries/en').then(async function (response) {
            setCountries(response.data.data);
            setTimeout(function () {

                if (document.getElementById('nursingCourse').innerHTML != null) {
                    var nursingCourse = document.getElementById('nursingCourse').innerHTML;
                    if (nursingCourse != null) {
                        setCourseDiv(nursingCourse);
                        document.getElementById('nursingCourse').innerHTML = '<div></div>';
                    }
                }
                

            }, 1000)

        }).catch(function (error) {
            console.log(error);
        });
    }

    const _loadNationality = () => {
        get('nationality/en').then(async function (response) {
            setNationality(response.data.data);
        }).catch(function (error) {
            console.log(error);
        });
    }

    const _loadSpeaking = () => {
        get('speaking/en').then(async function (response) {
            setSpeaking(response.data.data);
        }).catch(function (error) {
            console.log(error);
        });
    }

    const _loadHobbies = () => {
        get('hobbies/en').then(async function (response) {
            setHobbies(response.data.data);
        }).catch(function (error) {
            console.log(error);
        });
    }

    const _loadDesignations = () => {
        get('destinations/en').then(async function (response) {
            setDesignations(response.data.data);
        }).catch(function (error) {
            console.log(error);
        });
    }

    const _addLanguageSkills = () => {
        var language = document.getElementById('language');
        var language_level = "";
        //document.getElementById('language_level').value;

        if (language.value) {

            var exists = false;
            for (var i = 0; i < languageSkills.length; i++) {
                if (languageSkills[i].language == language.value && languageSkills[i].level == language_level) {
                    exists = true;
                }
            }

            var tmp = {
                name: language.options[language.selectedIndex].text,
                language: language.value,
                level: language_level
            }

            if (exists == false)
                setLanguageSkills([...languageSkills, tmp]);
        }
    }

    const enableEdit = (e) => {
        setSaveBtn(true)
    }

    Element.prototype.insertAfter = function (newEl) {
        this.parentNode.insertBefore(newEl, this.nextSibling);
    }

    function multipleInArray(arr, values) {
        return values.every(value => {
            return arr.includes(value);
        });
    }

    const save = (e) => {
        removeErrors();
        var error = false;

        var elements = document.getElementsByClassName('required');
        for (var i = 0; i < elements.length; i++) {
            var error_message = elements[i].getAttribute('data-error');

            if (elements[i].value == "") {
                createError(elements[i], error_message);
                error = true;
            }
        }

        var courseData = [];
        var school_details = "";
        var course_details = "";
        var experienceData = [];
        var collegeData = [];

        if (myProfile.candidate_degree == 'STUDENT') {
            var school_start = document.getElementsByName('school_start[]');
            var school_end = document.getElementsByName('school_end[]');
            var class_from = document.getElementsByName('class_from[]');
            var class_to = document.getElementsByName('class_to[]');
            var school = document.getElementsByName('school[]');
            var school_country = document.getElementsByName('school_country[]');

            var schoolData = [];
            var collegeData = [];

            for (var j = 0; j < school_start.length; j++) {
                if (school_start[j].value) {
                    schoolData.push({
                        school_start: school_start[j].value,
                        school_end: school_end[j].value,

                        class_from: class_from[j].value,
                        class_to: class_to[j].value,

                        school: school[j].value,
                        country: school_country[j].value
                    })
                }

            }

            var college_start = document.getElementsByName('college_start[]');
            var college_end = document.getElementsByName('college_end[]');
            var college_school = document.getElementsByName('college_school[]');
            var college_course = document.getElementsByName('college_course[]');
            var college_state = document.getElementsByName('college_state[]');
            var college_country = document.getElementsByName('college_country[]');

            for (var j = 0; j < college_start.length; j++) {
                if (college_start[j].value) {
                    collegeData.push({
                        college_start: college_start[j].value,
                        college_end: college_end[j].value,

                        college_school: college_school[j].value,
                        college_course: college_course[j].value,

                        college_state: college_state[j].value,
                        country: college_country[j].value
                    })
                }

            }
        }
        else {
            var nc_start = document.getElementsByName('nc_start[]');
            var nc_end = document.getElementsByName('nc_end[]');
            var nc_course = document.getElementsByName('nc_course[]');
            var nc_college = document.getElementsByName('nc_college[]');
            var nc_university = document.getElementsByName('nc_university[]');
            var nc_state = document.getElementsByName('nc_state[]');
            var nc_country = document.getElementsByName('nc_country[]');
            var tmp = [];

            for (var j = 0; j < nc_start.length; j++) {
                for (var k = 0; k < tmp.length; k++) {
                    if (tmp[k] == nc_course[j].value) {
                        alert("Nursing courses are often selected repeatedly");
                        error = true;
                        return false;
                    }
                }

                tmp.push(nc_course[j].value);

                if (nc_start[j].value) {
                    courseData.push({
                        nc_start: nc_start[j].value,
                        nc_end: nc_end[j].value,

                        nc_course: nc_course[j].value,
                        nc_college: nc_college[j].value,

                        nc_university: nc_university[j].value,
                        nc_state: nc_state[j].value,

                        nc_country: nc_country[j].value
                    })
                }
            }
        }

        if (error == false) {

            var first_name = document.getElementById('first_name').value;
            var last_name = document.getElementById('last_name').value;
            var phone = document.getElementById('phone').value;
            var email = document.getElementById('email').value;
            var gender = document.getElementById('gender').value;
            var family_status = document.getElementById('family_status').value;
            var country = document.getElementById('country').value;
            var nationality = document.getElementById('nationality').value;
            //var passport_number = document.getElementById('passport_number').value;
            //var passport_expiry_date = document.getElementById('passport_expiry_date').value;
            var present_address = "";//document.getElementById('present_address').value;
            var present_address_passport = "";//document.getElementById('present_address_passport').value;
            var dob = document.getElementById('dob').value;

            /*EDUCATIONAL DETAILS HIGHER SECONDARY*/
            var hs_start = document.getElementById('hs_start').value;
            var hs_end = document.getElementById('hs_end').value;
            var hs_school = document.getElementById('hs_school').value;
            var hs_university = document.getElementById('hs_universiry').value;
            var hs_state = document.getElementById('hs_state').value;
            var hs_country = document.getElementById('hs_country').value;

            /*EDUCATIONAL DETAILS NURSING*/
            if (myProfile.candidate_degree != 'STUDENT') {
                var nc_start = document.getElementById('nc_start').value;
                var nc_end = document.getElementById('nc_end').value;
                var nc_course = document.getElementById('nc_course').value;
                var nc_college = document.getElementById('nc_college').value;
                var nc_university = document.getElementById('nc_universiry').value;
                var nc_state = document.getElementById('nc_state').value;
                var nc_country = document.getElementById('nc_country').value;
            }
            else {
                var nc_total_experience, nc_start, nc_end, nc_course, nc_college, nc_university, nc_state, nc_country, experience_bed_capacity, experience_employer, experience_designation, experience_start, experience_end = '';
            }

            for (var i = 0; i < 10; i++) {

                var ed = {
                    experience_start: document.getElementById('experience_start_' + i).value,
                    experience_end: document.getElementById('experience_end_' + i).value,
                    experience_designation: document.getElementById('experience_designation_' + i).value,
                    experience_employer: document.getElementById('experience_employer_' + i).value,
                    experience_bed_capacity: getDepartmentIds(document.getElementById('experience_bed_capacity_' + i).value, departments)
                }

                if (document.getElementById('experience_start_' + i).value != "") {
                    experienceData.push(ed);
                }

            }

            var experience_start = document.getElementById('experience_start_0').value;
            var experience_end = document.getElementById('experience_end_0').value;
            var experience_designation = document.getElementById('experience_designation_0').value;
            var experience_employer = document.getElementById('experience_employer_0').value;
            var experience_bed_capacity = getDepartmentIds(document.getElementById('experience_bed_capacity_0').value, departments);
            var nc_total_experience = document.getElementById('nc_total_experience').value;


            var languageSkillsCandidate = JSON.stringify(languageSkills);
            var hobbiesElements = document.getElementsByClassName('hobbies');
            var hobbies = [];

            for (var j = 0; j < hobbiesElements.length; j++) {
                if (hobbiesElements[j].checked) {
                    hobbies.push(hobbiesElements[j].value);
                }
            }

            var candidateHobbies = JSON.stringify(hobbies);
            var lc_language_level = document.getElementById('lc_language_level').value;
            var lc_start = document.getElementById('lc_start').value;
            var lc_end = document.getElementById('lc_end').value;
            var lc_school = document.getElementById('lc_school').value;
            var lc_state = document.getElementById('lc_state').value;
            var lc_country = document.getElementById('lc_country').value;

            var additionalNote = document.getElementById('additional_note').value;
            var mother_tongue = document.getElementById('mother_tongue').value;
            var birth_place = document.getElementById('birth_place').value;

            var permanent_address_line1 = document.getElementById(
                "permanent_address_line1").value;
            var permanent_address_line2 = document.getElementById(
                "permanent_address_line2").value;
            var permanent_city = document.getElementById(
                "permanent_city").value;
            var permanent_state = document.getElementById("permanent_state").value;
            var permanent_pincode = document.getElementById(
                "permanent_pincode").value;


            var present_address_line1 = document.getElementById(
                "present_address_line1").value;
            var present_address_line2 = document.getElementById(
                "present_address_line2").value;
            var present_city = document.getElementById(
                "present_city").value;
            var present_state = document.getElementById("present_state").value;
            var present_pincode = document.getElementById(
                "present_pincode").value;

            var raw = JSON.stringify({
                "candidate_id": props.params.id,
                "candidate_residency": country,
                "candidate_nationality": nationality,
                "candidate_gender": gender,
                "candidate_family_status": family_status,
                "candidate_passport_details": "",
                "candidate_passport_expiry_date": "",
                "candidate_address": present_address,
                "candidate_passport_address": present_address_passport,
                "candidate_last_name": last_name,
                "candidate_first_name": first_name,
                "candidate_dob": dob,
                "candidate_hs_start": hs_start,
                "candidate_hs_end": hs_end,
                "candidate_hs_school": hs_school,
                "candidate_hs_university": hs_university,
                "candidate_hs_state": hs_state,
                "candidate_hs_country": hs_country,
                "candidate_nc_start": nc_start,
                "candidate_nc_end": nc_end,
                "candidate_nc_course": nc_course,
                "candidate_nc_college": nc_college,
                "candidate_nc_university": nc_university,
                "candidate_nc_state": nc_state,
                "candidate_nc_country": nc_country,
                "candidate_languageSkills": languageSkills,
                "candidate_hobbies": candidateHobbies,
                "candidate_experience_total": nc_total_experience,
                "candidate_experience_start": experience_start,
                "candidate_experience_end": experience_end,
                "candidate_experience_designation": experience_designation,
                "candidate_experience_employer": experience_employer,
                "candidate_experience_bed_capacity": experience_bed_capacity,
                "candidate_school_details": JSON.stringify(schoolData),
                "candidate_nc_course_details": JSON.stringify(courseData),
                "candidate_college_details": JSON.stringify(collegeData),
                "candidate_experince": JSON.stringify(experienceData),
                "candidate_additional_note": additionalNote,
                "lc_language_level": lc_language_level,
                "lc_start": lc_start,
                "lc_end": lc_end,
                "lc_school": lc_school,
                "lc_state": lc_state,
                "lc_country": lc_country,
                "mother_tongue": mother_tongue,
                "candidate_email": email,
                "candidate_phone": phone,
                "candidate_birth_place": birth_place,
                "candidate_permanent_address_line1": permanent_address_line1,
                "candidate_permanent_address_line2": permanent_address_line2,
                "candidate_permanent_city": permanent_city,
                "candidate_permanent_state": permanent_state,
                "candidate_permanent_pincode": permanent_pincode,
                "candidate_present_address_line1": present_address_line1,
                "candidate_present_address_line2": present_address_line2,
                "candidate_present_city": present_city,
                "candidate_present_state": present_state,
                "candidate_present_pincode": present_pincode,
            });

            setLoading(true);
            put('candidates/admin', raw).then(async function (response) {
                setLoading(false);
                setSaveBtn(false);
                _loadProfile();

                if (candidateStatus == 1) {
                    setStep("1");
                    window.location.href = "/documents";
                }
            }).catch(function (error) {
                setLoading(false);
                console.log(error);
            });

        }
    }

    const experiences = () => {
        var experiences = [];

        for (var i = 1; i <= 20; i++) {
            experiences.push(<option value={i}>{i + " Years"}</option>);
        }

        return experiences;
    }

    const experienceDetails = () => {
        var data = [];
        var required = 'required';
        for (var j = 0; j < 10; j++) {
            data.push(
                <div className='row'>
                    <div className="col-sm-2 form-group">
                        <label className="mb-3 top-label">
                            <input type="date" id={"experience_start_" + j} className={"form-control " + required} data-error="Enter start date" />
                            <span style={{ color: 'rgb(94, 92, 92)' }}>Start Date</span>
                        </label>
                    </div>

                    <div className="col-sm-2 form-group">
                        <label className="mb-3 top-label">
                            <input type="date" id={"experience_end_" + j} className={"form-control " + required} data-error="Enter end date" />
                            <span style={{ color: 'rgb(94, 92, 92)' }}>End Date</span>
                        </label>
                    </div>

                    <div className="col-sm-2 form-group">
                        <label className="mb-3 top-label">
                            <select className={"form-control " + required} id={"experience_designation_" + j} data-error="Please select designation">
                                {
                                    designations.map((d, k) =>
                                        <option value={d.destination_id}>
                                            {d.destination_name}
                                        </option>
                                    )
                                }
                            </select>
                            <span style={{ color: 'rgb(94, 92, 92)' }}>Designation</span>
                        </label>
                    </div>

                    <div className="col-sm-4 form-group">
                        <label className="mb-3 top-label">
                            <input type="text" id={"experience_employer_" + j} className={"form-control " + required} data-error="Enter employer name" />
                            <span style={{ color: 'rgb(94, 92, 92)' }}>Employer Name</span>
                        </label>
                    </div>

                    <div className="col-sm-2 form-group">
                        <label className="mb-3 top-label">
                            <input type="text" id={"experience_bed_capacity_" + j} className={"form-control " + required} data-error="Enter department" />
                            <span style={{ color: 'rgb(94, 92, 92)' }}>Department</span>
                        </label>
                    </div>
                </div>
            );

            required = '';
        }

        return data;
    }

    const uploadFile = (e) => {
        const file = e.target.files[0];
        const formData = new FormData();
        formData.append('file', file);
        formData.append('candidateId', props.params.id);
        setImage(URL.createObjectURL(e.target.files[0]));
        setLoading(true);

        /*var reader = new FileReader();

        reader.onload = function (e) {
            setImage(e.target.result);
        };*/

        //const imageSrc = URL.createObjectURL(file[0]);
        //setImage(image);

        /*post('admin/translators/document_upload', formData)
            .then(res => {
                _loadDocuments(1);
                alert("Successfully Uploaded!");
            }).catch(err => console.log(err));*/



        const headers = {
            "Contetnt-Type": "multipart/form-data",
        }

        axios.post(process.env.REACT_APP_BASE_URL + 'candidates/avatar_upload', formData, {
            headers: headers
        })
            .then((res) => {
                setLoading(false);
                alert("Successfully Uploaded!");
                //window.location.href = "/profile";
            })
            .catch((error) => {
                setLoading(false);
                alert('Avatar upload failed, Please try agian')
            })
    }

    const plusSchool = () => {
        //console.log(schoolsDiv)
        //document.getElementById("schools_div").appendChild(schoolsDiv);
        var sDiv = "";
        setSchoolsArr([...schoolsArr, schoolsDiv]);
    }

    const plusCourse = () => {
        var limit = 3;
        if (myProfile.candidate_nurse_course.length > 0) {
            limit = 4 - myProfile.candidate_nurse_course.length;
        }
        if (courseArr.length < limit) {
            setCourseArr([...courseArr, courseDiv]);
        }

    }

    const _saveLanguageSkills = () => {
        var language = document.getElementById("change_language_level").value;

        var raw = JSON.stringify({
            "candidate_language_level": language
        });

        setLoading(true);
        put('candidates/change_language', raw).then(async function (response) {
            setLoading(false);
            setSaveBtn(false);
            _loadProfile();
        }).catch(function (error) {
            console.log(error);
            setLoading(false);
        });

    }

    var languageLevels = {
        NOT_ENTROLLED: "Not yet enrolled",
        A1_ENTROLLED: "A1 Enrolled",
        A1_COMPLETE: "A2 Complete",
        B1_COMPLETE: "B1 Complete",
        B2_COMPLETE: "B2 Complete",
        C1_COMPLETE: "C1 Complete",
        C2_COMPLETE: "C2 Complete",
    };

    var languageLevelsId = [
        { id: "NOT_ENTROLLED", val: "Not yet enrolled" },
        { id: "A1_ENTROLLED", val: "A1 Enrolled" },
        { id: "A1_COMPLETE", val: "A2 Complete" },
        { id: "B1_COMPLETE", val: "B1 Complete" },
        { id: "B2_COMPLETE", val: "B2 Complete" },
        /*{ id: "C1_COMPLETE", val: "C1 Complete" },
        { id: "C2_COMPLETE", val: "C2 Complete" },*/
    ];



    const _remove = (index) => {
        removeProduct(index)
    }

    const removeProduct = (index) => {
        setCourseArr([
            ...courseArr.slice(0, index),
            ...courseArr.slice(index + 1, courseArr.length)
        ]);
    }

    const removeErrors = () => {
        var ele = document.querySelectorAll(".error");

        for (var j = 0; j < ele.length; j++) {
            ele[j].remove();
        }
    }

    const createError = (element, error) => {
        var errorElement = document.createElement("div");
        errorElement.classList.add('error');
        errorElement.innerHTML = error;
        element.insertAfter(errorElement);
        element.focus();
    }

    const _changePassword = () => {
        var password = document.getElementById('password').value;
        var confirm = document.getElementById('confirm_password').value;

        if (password.length == 0) {
            alert("Please enter valid password");
            return false;
        }

        if (password != confirm) {
            alert("Password and confirm password do not match");
            return false;
        }

        var raw = JSON.stringify({
            "candidate_id": props.params.id,
            "password": password
        });

        setLoading(true);
        post('admin/candidates/change_p', raw).then(async function (response) {
            setLoading(false);
            alert("Successfully updated");
        }).catch(function (error) {
            setLoading(false);
        });

    }

    const _addNote = () => {
        var note = document.getElementById('note').value;

        if (note.length == 0) {
            alert("Please enter note");
            return false;
        }

        var raw = JSON.stringify({
            "candidate_id": props.params.id,
            "note": note
        });

        setLoading(true);
        post('admin/candidates/note', raw).then(async function (response) {
            setLoading(false);
            alert("Successfully updated");
            //document.getElementById('note').value = "";
        }).catch(function (error) {
            setLoading(false);
        });
    }

    var languageCourseLevels = [
        { id: "Im Moment lerne A1 Niveau", val: "Im Moment lerne A1 Niveau" },
        { id: "Im Moment lerne A2 Niveau", val: "Im Moment lerne A2 Niveau" },
        { id: "Im Moment lerne B1 Niveau", val: "Im Moment lerne B1 Niveau" },
        { id: "mit Abschluss Zertifikat B1", val: "mit Abschluss Zertifikat B1" },
        { id: "Im Moment lerne B2 Niveau", val: "Im Moment lerne B2 Niveau" },
        { id: "mit Abschluss Zertifikat B2", val: "mit Abschluss Zertifikat B2" },
    ];

    const _changeStatus = () => {
        var affiliate_status = document.getElementById('affiliate_status').value;
        var affiliator_note = document.getElementById('affiliator_note').value;
        var affiliator = document.getElementById('affiliator').value;

        var e = document.getElementById("affiliator");
        var option = e.options[e.selectedIndex];
        var datarc = option.getAttribute("data-id");

        var raw = JSON.stringify({
            "candidate_id": props.params.id,
            "affiliate_status": affiliate_status,
            "affiliator_note": affiliator_note,
            "affiliator": affiliator,
            "affiliator_code": datarc
        });

        setLoading(true);
        post('admin/candidates/change_affiliate_status', raw).then(async function (response) {
            setLoading(false);
            alert("Successfully updated");
        }).catch(function (error) {
            setLoading(false);
        });
    }

    const _changeCandidateStatus = (cstatus) => {
        setCandidateStatus(cstatus);

        if (cstatus == 1) {
            document.getElementById("not_started").checked = true;
        }

        if (cstatus == 2) {
            document.getElementById("in_progress").checked = true;
        }

        if (cstatus == 3) {
            document.getElementById("completed").checked = true;
        }

        var raw = JSON.stringify({
            "candidate_id": props.params.id,
            "candidate_status": cstatus,
        });

        setLoading(true);
        post('admin/candidates/change_candidate_status', raw).then(async function (response) {
            setLoading(false);
            alert("Successfully updated");
        }).catch(function (error) {
            setLoading(false);
        });
    }

    return (
        <>
            <Header />
            <Loader loading={loading} />

            <main>
                <div class="container">
                    <div class="page-title-container">
                        <div class="row">
                            <div class="col-12 col-md-7">
                                <span class="align-middle text-muted d-inline-block lh-1 pb-2 pt-2 text-small"></span>
                                <h1 class="mb-0 pb-0 display-4 text-capitalize" id="title">
                                    {/* <a href="/candidates">
                                        <i data-acorn-icon="arrow-left" class="icon" data-acorn-size="25"></i>
                                    </a> */}
                                </h1>
                            </div>
                        </div>
                    </div>



                    <div style={{ display: 'none' }}>
                        <div className='row' id="nursingCourse">

                            <label className="col-sm-4 mb-3 top-label">
                                <input type="text" name="nc_start[]" id="nc_start_" className="form-control required date-picker" data-error="Nursing starting month & year" />
                                <span style={{ color: 'rgb(94, 92, 92)', textTransform: 'capitalize' }}>Starting month & year</span>
                            </label>

                            <label className="col-sm-4 mb-3 top-label">
                                <input type="text" name="nc_end[]" id="nc_end_" className="form-control required date-picker" data-error="Higher secondary ending month & year" />
                                <span style={{ color: 'rgb(94, 92, 92)', textTransform: 'capitalize' }}>Ending month & year</span>
                            </label>

                            <label className="col-sm-4 mb-3 top-label">
                                <select name="nc_course[]" className="form-control required" id="nc_course_" data-error="Please select nursing course">
                                    <option value="">Select</option>
                                    <option value="1">B.Sc Nursing 4 years course</option>
                                    <option value="2">M.Sc Nursing 2 years course</option>
                                    <option value="3">Diploma in Nursing/GNM 3.5 years course</option>
                                    <option value="4">Post Basic B.Sc 2 years course</option>
                                    <option value="5">Diploma in Nursing/GNM 3 years course</option>
                                </select>
                                <span style={{ color: 'rgb(94, 92, 92)', textTransform: 'capitalize' }}>Nursing Course</span>
                            </label>

                            <label className="col-sm-4 mb-3 top-label">
                                <input type="text" name="nc_college[]" id="nc_college_" className="form-control required" data-error="Enter your college" />
                                <span style={{ color: 'rgb(94, 92, 92)', textTransform: 'capitalize' }}>College name</span>
                            </label>

                            <label className="col-sm-4 mb-3 top-label">
                                <input type="text" name="nc_university[]" id="nc_universiry_" className="form-control required" data-error="Enter your University/ Board name" />
                                <span style={{ color: 'rgb(94, 92, 92)', textTransform: 'capitalize' }}>University/ Board name</span>
                            </label>

                            <label className="col-sm-4 mb-3 top-label">
                                <input type="text" name="nc_state[]" id="nc_state_" className="form-control required" data-error="Enter state" />
                                <span style={{ color: 'rgb(94, 92, 92)', textTransform: 'capitalize' }}>State</span>
                            </label>


                            <label className="col-sm-4 mb-3 top-label">
                                <select name="nc_country[]" id="nc_country_" className="form-control required" data-error="Please select country">
                                    <option value="">Select</option>
                                    {
                                        countries.map((c, k) =>
                                            <option value={c.country_id} key={k}>
                                                {c.country_name}
                                            </option>
                                        )
                                    }
                                </select>
                                <span style={{ color: 'rgb(94, 92, 92)', textTransform: 'capitalize' }}>Country</span>
                            </label>
                            <hr />
                        </div>
                    </div>

                    <div className='row'>

                        <div className='col-xl-12'>

                            <div className='row'>
                                <div class="col-3 col-sm-3 col-lg-3 text-center">
                                    <label htmlFor="uploadDoc"><img className="img-fluid rounded-md" src={image} style={{ width: 150, height: 150 }} /></label>
                                    <input className="d-none btn btn-outline-primary btn-icon btn-icon-start w-100 w-md-auto" accept="image/*" type="file" style={{ zIndex: 2, top: 0, left: 0, filter: 'alpha(opacity=0)', msFilter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)" }} name="file_source" size="40" onChange={(e) => uploadFile(e)} id="uploadDoc" />
                                    <br/><a targe="_blank" download={image} href={image} className='mt-1'>Download</a>
                                </div>
                                <div className='col-sm-3'>
                                    <h3 class="alert-heading" style={{ textTransform: 'capitalize', fontWeight: 'bold' }}>{myProfile.candidate_first_name} {myProfile.candidate_last_name}</h3>
                                    <span>{myProfile.candidate_email}</span><br /><span>{myProfile.candidate_phone}</span>
                                </div>
                                <div class="col-12 col-sm-6 col-lg-3">
                                    <div class="mb-5">
                                        <div>
                                            <div class="heading mb-0 d-flex justify-content-between lh-1-25 mb-3">
                                                <span>Language Level</span>
                                            </div>
                                            <div class="text-small text-muted mb-1"></div>
                                            <div class="cta-1 text-primary">
                                                {myProfile.candidate_current_language_level == 'NOT_ENTROLLED' ? 'Not yet enrolled' : ''}
                                                {myProfile.candidate_current_language_level == 'A1_ENTROLLED' ? 'A1 Enrolled' : ''}
                                                {myProfile.candidate_current_language_level == 'A1_COMPLETE' ? 'A2 Complete' : ''}

                                                {myProfile.candidate_current_language_level == 'B1_COMPLETE' ? 'B1 Complete' : ''}
                                                {myProfile.candidate_current_language_level == 'B2_COMPLETE' ? 'B2 Complete' : ''}
                                                {myProfile.candidate_current_language_level == 'C1_COMPLETE' ? 'C1 Complete' : ''}

                                                {myProfile.candidate_current_language_level == 'C2_COMPLETE' ? 'C2 Complete' : ''}
                                            </div>
                                        </div>
                                        <div class="mb-5">
                                        <div>
                                            <div class="heading mb-0 d-flex justify-content-between lh-1-25 mb-3 pt-5">
                                                <span>KDA Brochure Status</span>
                                            </div>
                                            <div class="text-small text-muted mb-1"></div>
                                            <div class="cta-1 text-primary">
                                                {myProfile.has_read_information_brochure_2024 == true ? "Read" : "Read"} ({myProfile.has_read_information_brochure_2024_time ? new Date(myProfile.has_read_information_brochure_2024_time).toLocaleDateString('en-GB') : "N/A"})
                                            </div>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-6 col-lg-3">
                                    <div class="heading mb-0 d-flex justify-content-between lh-1-25 mb-3">
                                        <span>Agreement Status</span>
                                    </div>
                                    <div class="text-small text-muted mb-1"></div>
                                    <div class="cta-1 text-primary">
                                        {myProfile.agreement_status == 1 ? "Signed" : "Not Signed"}
                                    </div>

                                    <div class="mb-5"></div>

                                    <div class="heading mb-0 d-flex justify-content-between lh-1-25 mb-3">
                                        <span>Agreement Date</span>
                                    </div>
                                    <div class="text-small text-muted mb-1"></div>
                                    <div class="cta-1 text-primary">
                                        {myProfile.agreement_date ? new Date(myProfile.agreement_date).toLocaleDateString('en-GB') : "N/A"}
                                    </div>
                                </div>

                                {/*<div class="col-12 col-sm-6 col-lg-3">
                                    <div class="mb-5">
                                        <div>
                                            <div class="heading mb-0 d-flex justify-content-between lh-1-25 mb-3">
                                                <span>Meeting Status</span>
                                            </div>
                                            <div class="text-small text-muted mb-1"></div>
                                            <div class="cta-1 text-primary">
                                                {myProfile.candidate_status == 1 ? "Attend" : "Not Attend"}
                                            </div>
                                        </div>
                                    </div>
                                </div>*/}
                            </div>

                            <div className='row'>
                                <div className='col-sm-12'>
                                    <div className='card mt-5'>
                                        <div className='card-body'>
                                            <h4>Candidate Status</h4>
                                            <div class="col-sm-12 col-md-12 col-lg-12 col-xxl-12 mb-1">

                                                <div class="form-check form-check-inline">
                                                    <input class="form-check-input" type="radio" name="inlineRadioOptions" id="not_started" value="not_started" onClick={() => _changeCandidateStatus('1')} />
                                                    <label class="form-check-label" for="inlineRadio1">Not Started</label>
                                                </div>

                                                <div class="form-check form-check-inline">
                                                    <input class="form-check-input" type="radio" name="inlineRadioOptions" id="in_progress" value="in_progress" onClick={() => _changeCandidateStatus('2')} />
                                                    <label class="form-check-label" for="inlineRadio2">In Progress </label>
                                                </div>

                                                <div class="form-check form-check-inline">
                                                    <input class="form-check-input" type="radio" name="inlineRadioOptions" id="completed" value="completed" onClick={() => _changeCandidateStatus('3')} />
                                                    <label class="form-check-label" for="inlineRadio3">Completed </label>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-sm-6'>
                                    <div className='card mt-5'>
                                        <div className='card-body'>
                                            <div className="col-sm-12">
                                                <label>Affiliator</label>
                                                <select className='form-control' id="affiliator">
                                                    <option value=''>Select Affiliator</option>
                                                    {
                                                        affliators.map((a, k) =>
                                                            <option value={a._id} data-id={a.affiliator_id}>{a.affiliator_name} [ {a.affiliator_id} ] </option>
                                                        )
                                                    }
                                                </select>
                                            </div>

                                            <div className="col-sm-12">
                                                <label>Change status for affiliates</label>
                                                <select className='form-control' id="affiliate_status">
                                                    <option value='under review'>Under Review</option>
                                                    <option value='in progress'>In Progress</option>
                                                    <option value='interview completed'>Interview Completed</option>
                                                    <option value='candidate joined'>Candidate Joined</option>
                                                    <option value='get paid'>Get Paid</option>
                                                    <option value='rejected'>Rejected</option>
                                                </select>
                                            </div>

                                            <div className="col-sm-12">
                                                <label>Notes</label>
                                                <input type='text' className='form-control' name='affiliator_note' id='affiliator_note' />
                                            </div>
                                            <div className='col-2 top-label'>
                                                <button class="btn btn-primary" type="button" onClick={() => _changeStatus()} style={{ marginTop: 22 }}>Update</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className='col-sm-6'>
                                    <div className='card mt-5'>
                                        <div className='card-body'>
                                            <div className="col-sm-12 top-label mt-5">
                                                <input type="password" id="password" className="form-control" data-error="New Password" name="password" />
                                                <span style={{ color: 'rgb(94, 92, 92)', textTransform: 'uppercase' }}>New Password</span>
                                            </div>
                                            <div className="col-sm-12 top-label mt-4">
                                                <input type="password" id="confirm_password" className="form-control " data-error="Confirm Password" name="confirm_password" />
                                                <span style={{ color: 'rgb(94, 92, 92)', textTransform: 'uppercase' }}>Confirm Password</span>
                                            </div>
                                            <div className="col-sm-12 mb-3 top-label mt-4">
                                                <button class="btn btn-primary" type="button" onClick={() => _changePassword()}>Change Password</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-12 col-lg-12 col-xxl-12 mb-1 mt-5">
                                
                                <div className='card'>
                                    <div className='card-body'>
                                        <h2 class="small-title" style={{ margin: 0 }}>Note</h2>
                                        <div className="col-sm-12 col-md-12 col-lg-12 col-xxl-12 mb-1">
                                            <div className='card mb-5'>
                                                <div className='card-body p0' style={{ padding: 0 }}>
                                                    <textarea className='form-control' id="note" style={{ height: 100 }} defaultValue={myProfile.candidate_note}></textarea><br />
                                                    <button class="btn btn-primary" type="button" onClick={() => _addNote()}>Add Note</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/*<div className='card mb-5 mt-5'>
                                        <div className='card-body'>
                                            <h3 className="mb-2 pb-0 display-6" id="title">Hobbies</h3><hr />
                                            <div className='row'>
                                                {
                                                    hobbies.map((h, k) =>
                                                        <div className=" col-sm-3 form-group">
                                                            <div className="form-check mt-2">
                                                                <input type="checkbox" className="hobbies form-check-input" value={h.hobby_id} id={"hb_" + h.hobby_id} />
                                                                <label className="form-check-label" htmlFor={"hb_" + h.hobby_id} style={{ textTransform: 'capitalize' }}>{h.hobby_name}</label>
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                            </div>
                                        </div>
                                            </div>*/}

                            </div>
                        </div>
                    </div>
                </div>
            </main>
            <Footer />
        </>
    )
}



// Convert IDs to Names
function getDepartmentNames(rawValues, departments) {
    // Handle single ID or comma-separated IDs
    const deptIds = rawValues.includes(',') ? 
        rawValues.split(',').map(item => item.trim()) : 
        [rawValues];

    // Create ID to Name mapping
    const departmentMap = departments.reduce((map, dept) => {
        map[dept.department_id] = dept.department_name;
        return map;
    }, {});

    // Convert IDs to names and join
    const deptNames = deptIds
        .map(id => departmentMap[id] || '')
        .filter(Boolean)
        .join(', ');

    return deptNames;
}

// Convert Names to IDs
function getDepartmentIds(departmentNames, departments) {
    // Handle string or array input
    const deptNamesArray = Array.isArray(departmentNames) ? 
        departmentNames : 
        departmentNames.split(',').map(name => name.trim());

    // Create Name to ID mapping
    const nameToIdMap = departments.reduce((map, dept) => {
        map[dept.department_name] = dept.department_id;
        return map;
    }, {});

    // Convert names to IDs and join
    const deptIds = deptNamesArray
        .map(name => nameToIdMap[name])
        .filter(Boolean)
        .join(',');

    return deptIds;
}

export default withParams(CandidateProfile);